import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-riama-white shadow-md py-4">
      <div className="container mx-auto flex justify-between items-center px-4">
        {/* Logo */}
        <NavLink to="/">
          <img src={logo} alt="Logo RIAMA" className="w-36" />
        </NavLink>

        {/* Burger Menu Button */}
        <button
          className="lg:hidden text-riama-orange focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>

        {/* Menu Desktop */}
        <nav className="hidden lg:flex space-x-8 text-lg font-medium">
          <NavLink
            to="/chi-sono"
            className={({ isActive }) =>
              isActive
                ? "text-riama-red"
                : "text-riama-orange hover:text-riama-red"
            }
          >
            Chi Sono
          </NavLink>
          <NavLink
            to="/le-pratiche"
            className={({ isActive }) =>
              isActive
                ? "text-riama-red"
                : "text-riama-orange hover:text-riama-red"
            }
          >
            Le Pratiche
          </NavLink>
          <NavLink
            to="/contatti"
            className={({ isActive }) =>
              isActive
                ? "text-riama-red"
                : "text-riama-orange hover:text-riama-red"
            }
          >
            Contatti
          </NavLink>
        </nav>

        {/* Menu Mobile */}
        {isMenuOpen && (
          <div
            className="fixed top-0 left-0 w-full h-screen bg-riama-white z-50 shadow-md lg:hidden"
            style={{ height: "100vh" }}
          >
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 text-riama-red focus:outline-none"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>

            <nav className="flex flex-col space-y-6 p-8 text-lg font-medium">
              <NavLink
                to="/chi-sono"
                className={({ isActive }) =>
                  isActive
                    ? "text-riama-red"
                    : "text-riama-orange hover:text-riama-red"
                }
                onClick={() => setIsMenuOpen(false)} // Chiude il menu al click
              >
                Chi Sono
              </NavLink>
              <NavLink
                to="/le-pratiche"
                className={({ isActive }) =>
                  isActive
                    ? "text-riama-red"
                    : "text-riama-orange hover:text-riama-red"
                }
                onClick={() => setIsMenuOpen(false)} // Chiude il menu al click
              >
                Le Pratiche
              </NavLink>
              <NavLink
                to="/contatti"
                className={({ isActive }) =>
                  isActive
                    ? "text-riama-red"
                    : "text-riama-orange hover:text-riama-red"
                }
                onClick={() => setIsMenuOpen(false)} // Chiude il menu al click
              >
                Contatti
              </NavLink>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;